export const MessageHubKey = {
  ChangeUser: 'ChangeUser'
};
